import type { WmtsTile } from "@/cache/PVSTileService/TileGetters/WMTSTileGetter/WMTSTile";
import type { Feature, FeatureCollection, Polygon } from "geojson";

export type WmtsDebugTile = Pick<WmtsTile, "x" | "y" | "z">;

function tileToLongitude(x: number, z: number): number {
  const tilesPerAxis = 2 ** z;
  return (x / tilesPerAxis) * 360 - 180;
}

function tileToLatitude(y: number, z: number): number {
  const tilesPerAxis = 2 ** z;
  const mercatorY = Math.PI * (1 - (2 * y) / tilesPerAxis);
  return (180 / Math.PI) * Math.atan(Math.sinh(mercatorY));
}

function toTileBoundaryFeature(tile: WmtsDebugTile): Feature<Polygon, { tileId: string }> {
  const north = tileToLatitude(tile.y, tile.z);
  const south = tileToLatitude(tile.y + 1, tile.z);
  const west = tileToLongitude(tile.x, tile.z);
  const east = tileToLongitude(tile.x + 1, tile.z);

  return {
    type: "Feature",
    properties: {
      tileId: `${tile.z}/${tile.x}/${tile.y}`,
    },
    geometry: {
      type: "Polygon",
      coordinates: [
        [
          [west, north],
          [east, north],
          [east, south],
          [west, south],
          [west, north],
        ],
      ],
    },
  };
}

export function wmtsTilesToDebugFeatureCollection(
  tiles: WmtsDebugTile[],
): FeatureCollection<Polygon, { tileId: string }> {
  const uniqueTiles = new Map<string, WmtsDebugTile>();
  for (const tile of tiles) {
    uniqueTiles.set(`${tile.z}/${tile.x}/${tile.y}`, tile);
  }

  return {
    type: "FeatureCollection",
    features: Array.from(uniqueTiles.values()).map(toTileBoundaryFeature),
  };
}
